import { EntityWithId } from 'src/queries/entity.types'
import { GenerateQueriesArgs, generateQueries } from 'src/queries/queryGenerator'

export const MARKETPLACE_ENDPOINT = 'marketplace'
export const MARKETPLACE_QUERY_KEY = 'marketplace'

export interface Marketplace extends EntityWithId {
  emailCtaBackgroundColor: string
  emailCtaFontColor: string
  logo: string
  name: string
}

const generateQueriesConfig: GenerateQueriesArgs<Marketplace> = {
  endpoint: MARKETPLACE_ENDPOINT,
  queryKey: MARKETPLACE_QUERY_KEY,
}

export const { useAllEntitiesQuery: useMarketplaceQuery } = generateQueries(generateQueriesConfig)
